import React from "react";
import ParticipantStatusSummaryTable from "./ParticipantStatusSummaryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const ParticipantStatusSummaryIndex = () => (
  <ReportProgramsPage
    TableComponent={ParticipantStatusSummaryTable}
    loadingMessage="Loading participant status summary..."
  />
);

export default ParticipantStatusSummaryIndex;
